import { ActivityType } from '.';

export class AgendaMeetingActivityListing
{
    constructor(
        public id:string,
        public title:string,
        public activityType:ActivityType,
        public start:Date,
        public end:Date,
        public agendaItemCount:number,
        public actionPointCount:number,
        public actionPointDoneCount:number,
        public actionPointDeadlinePassedCount:number,
        public participantCount:number
    ){}
}
